"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OffersNotFound = void 0;
var _typography = require("@cian/ui-kit/typography");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./OffersNotFound.css"));
var _mortgageLink = require("../../constants/mortgageLink");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OffersNotFound = _ref => {
  let {
    onMortgageLinkClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['image']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_typography.ArticleHeading4, {
    color: "black_100"
  }, "\u041D\u0435\u0442 \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439")), /*#__PURE__*/React.createElement(_typography.ArticleParagraph2, {
    color: 'gray60_100',
    textAlign: 'center'
  }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0438\u043B\u0438", ' ', /*#__PURE__*/React.createElement("a", {
    className: styles['link'],
    href: _mortgageLink.MORTGAGE_LINK,
    target: "blank",
    rel: "noreferrer",
    onClick: onMortgageLinkClick
  }, "\u043F\u043E\u0434\u0430\u0439\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443")));
};
exports.OffersNotFound = OffersNotFound;